import { QueryObserver, QueryObserverOptions } from '@tanstack/query-core';

import { getResourcePermissions, SharingEntityType } from '../../predict/src/core/api/sharing';

import { queryClient } from '../core/queryClient';

type GetResourcePermissionsResult = Awaited<ReturnType<typeof getResourcePermissions>>;
type ResourcePermissionsQueryOptions = Omit<QueryObserverOptions<GetResourcePermissionsResult>, 'queryKey' | 'queryFn'>;

export const resourcePermissionsQueryKey = (
  organisationId: string,
  workspaceId: string,
  entityType: SharingEntityType,
  entityId: string,
  isConsolidation: boolean
) => ['resource-permissions', organisationId, workspaceId, entityType, entityId, isConsolidation];

export const resourcePermissionsQuery = (
  workspaceId: string,
  organisationId: string,
  entityType: SharingEntityType,
  entityId: string,
  isConsolidation = false,
  options?: ResourcePermissionsQueryOptions
): QueryObserver<GetResourcePermissionsResult> =>
  new QueryObserver<GetResourcePermissionsResult>(queryClient, {
    queryKey: resourcePermissionsQueryKey(organisationId, workspaceId, entityType, entityId, isConsolidation),
    queryFn: () => getResourcePermissions(workspaceId, organisationId, entityType, entityId, isConsolidation),
    staleTime: 0,
    gcTime: 0,
    ...options
  });

export const clearResourcePermissionsQueryCache = (
  organisationId: string,
  workspaceId: string,
  entityType: SharingEntityType,
  entityId: string,
  isConsolidation = false
): void => {
  queryClient.invalidateQueries({
    queryKey: resourcePermissionsQueryKey(organisationId, workspaceId, entityType, entityId, isConsolidation)
  });
};
